import { styled } from '@mui/material/styles';
import { 
    Box,
    Dialog,
    TextField,
} from '@mui/material';
import {supportTheme} from '../../../theme';


export const DialogShell = styled(Dialog)(() => ({
    '& .MuiPaper-root': {
        backgroundColor: supportTheme.component.panel.background,
        color: supportTheme.color.text,
        borderRadius: supportTheme.component.panel.radius,
        border: supportTheme.component.panel.border,
        width: supportTheme.component.panel.maxWidth,
        height: supportTheme.component.panel.maxHeight,
        boxShadow: supportTheme.component.panel.shadow,
        position: supportTheme.component.panel.position,
        top: supportTheme.component.panel.top,
        right: supportTheme.component.panel.right,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
}))

export const DialogTextField = styled(TextField)(() => ({
    '& .MuiInputBase-root': {
        backgroundColor: supportTheme.component.field.background,
        color: supportTheme.component.field.color,
        borderRadius: supportTheme.component.field.borderRadius,
        border: supportTheme.component.field.border,
        minHeight: supportTheme.component.field.height,
        padding: supportTheme.component.field.padding,
    },
    '& .MuiInputBase-input': {
        padding: 0,
        '&::placeholder': {
            color: supportTheme.component.field.placeholder,
            opacity: 1,
        },
    },
}))

export const DialogHeader = styled(Box)(() => ({
    ...supportTheme.component.header,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 'auto',
}))

export const DialogFooter = styled(Box)(() => ({
    ...supportTheme.component.footer,
    display: 'flex',
}))